import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../lib/AuthContext";

// Rendering guard only. The real boundary is require_superadmin in
// apps/api/auth_utils.py — every /api/superadmin route is gated there.
export function RequireSuperAdmin({ children }) {
  const { me, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-slate-400" size={24} />
      </div>
    );
  }

  if (me?.role !== "superadmin") return <Navigate to="/" replace />;

  return children;
}
